function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2{fill:none;stroke:#fff;stroke-linecap:round;stroke-width:2px}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_6041",
  "data-name": "Group 6041",
  transform: "translate(-.512 -.591)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_6039",
  "data-name": "Group 6039",
  transform: "translate(.352 2.022)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4858",
  "data-name": "Path 4858",
  className: "cls-2",
  d: "m5469.165 6536.085-7.818-7.818",
  transform: "translate(-4006.186 -5516.699)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_6040",
  "data-name": "Group 6040",
  transform: "rotate(90 1458.234 1016.664)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4858-2",
  "data-name": "Path 4858",
  className: "cls-2",
  d: "m5469.165 6536.085-7.818-7.818",
  transform: "translate(-4006.186 -5516.699)"
})));

function SvgCloseError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "Group_6038",
    "data-name": "Group 6038",
    transform: "translate(-1447 -1005)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6145",
    "data-name": "Rectangle 6145",
    width: 24,
    height: 24,
    rx: 12,
    transform: "translate(1447 1005)",
    style: {
      fill: "#b54242"
    }
  }), _ref3));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseError);
export default __webpack_public_path__ + "static/media/close-error.d1007f09.svg";
export { ForwardRef as ReactComponent };